import cn from "classnames";
import type { FunctionComponent } from "react";
import { useMessages } from "@noa/client-store";
import { MessageInput } from "./message-input";
import { MessagesList } from "./messages-list";

interface ChatInterfaceProps {
  className?: string;
}

export const ChatInterface: FunctionComponent<ChatInterfaceProps> = ({ className }) => {
  const messages = useMessages();

  return (
    <div className={cn("flex flex-1 flex-col h-full overflow-hidden", className)}>
      <MessagesList messages={messages} />
      <MessageInput />
    </div>
  );
};
